// extracted by mini-css-extract-plugin
export default {"root":"SidebarNav_root__IMAzi","optional":"SidebarNav_optional__Hndw5","check-complete":"SidebarNav_check-complete__gcU8I"};